export default [
    {
        logoId: 1,
        name: "Chama Caótica",
        levelsInfo: [
            {
                level: 1,
                cooldown: 1,
                mp: 47,
                cast: 1,
                info:
                    "Causa 75 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 25 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 1,
            },
            {
                level: 2,
                cooldown: 1,
                mp: 59,
                cast: 1,
                info:
                    "Causa 94 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 27 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 4,
            },
            {
                level: 3,
                cooldown: 1,
                mp: 79,
                cast: 1,
                info:
                    "Causa 127 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 29 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 8,
            },
            {
                level: 4,
                cooldown: 1,
                mp: 101,
                cast: 1,
                info:
                    "Causa 161 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 31 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 12,
            },
            {
                level: 5,
                cooldown: 1,
                mp: 125,
                cast: 1,
                info:
                    "Causa 199 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 33 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 16,
            },
            {
                level: 6,
                cooldown: 1,
                mp: 155,
                cast: 1,
                info:
                    "Causa 246 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 35 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 20,
            },
            {
                level: 7,
                cooldown: 1,
                mp: 188,
                cast: 1,
                info:
                    "Causa 299 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 37 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 24,
            },
            {
                level: 8,
                cooldown: 1,
                mp: 228,
                cast: 1,
                info:
                    "Causa 362 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 39 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 28,
            },
            {
                level: 9,
                cooldown: 1,
                mp: 277,
                cast: 1,
                info:
                    "Causa 439 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 41 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 32,
            },
            {
                level: 10,
                cooldown: 1,
                mp: 335,
                cast: 1,
                info:
                    "Causa 531 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 43 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 36,
            },
            {
                level: 11,
                cooldown: 1,
                mp: 403,
                cast: 1,
                info:
                    "Causa 640 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 45 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 40,
            },
            {
                level: 12,
                cooldown: 1,
                mp: 476,
                cast: 1,
                info:
                    "Causa 756 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 47 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 44,
            },
            {
                level: 13,
                cooldown: 1,
                mp: 562,
                cast: 1,
                info:
                    "Causa 892 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 49 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 48,
            },
            {
                level: 14,
                cooldown: 1,
                mp: 653,
                cast: 1,
                info:
                    "Causa 1037 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 51 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 52,
            },
            {
                level: 15,
                cooldown: 1,
                mp: 755,
                cast: 1,
                info:
                    "Causa 1199 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 53 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 56,
            },
            {
                level: 16,
                cooldown: 1,
                mp: 869,
                cast: 1,
                info:
                    "Causa 1380 de dano mágico e queima o inimigo por 3 segundos. A habilidade possui 55 de crítico adicional e o alvo entra no efeito de Chamas.",
                necessaryLevel: 60,
            },
        ],
    },
    {
        logoId: 2,
        name: "Sofrimento",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 119,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 44 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 4,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 160,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 59 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 8,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 203,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 75 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 12,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 251,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 93 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 16,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 311,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 115 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 20,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 378,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 140 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 24,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 456,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 169 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 28,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 554,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 205 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 32,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 670,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 248 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 36,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 807,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 299 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 40,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 953,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 353 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 44,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 1126,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 417 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 48,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 1310,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 485 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 52,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 1516,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 561 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 56,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 1731,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 641 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 60,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 1958,
                cast: 0,
                info:
                    "Lança uma maldição no alvo que causa 725 de dano mágico por segundo durante 6 segundos. O alvo entra no efeito da Escuridão.",
                necessaryLevel: 64,
            },
        ],
    },
    {
        logoId: 3,
        name: "Polimorfo",
        levelsInfo: [
            {
                level: 1,
                cooldown: 40,
                mp: 54,
                cast: 2,
                info:
                    "Transforma o inimigo em um coelho durante 20 segundos reduzindo 20 da sua velocidade de movimento e também reduzindo significativamente sua vida, mana, defesa física e defesa mágica inibindo o alvo de contra-ataques. Efeito será cancelado caso o alvo receba algum ataque.",
                necessaryLevel: 6,
            },
            {
                level: 2,
                cooldown: 40,
                mp: 70,
                cast: 2,
                info:
                    "Transforma o inimigo em um coelho durante 22 segundos reduzindo 22 da sua velocidade de movimento e também reduzindo significativamente sua vida, mana, defesa física e defesa mágica inibindo o alvo de contra-ataques. Efeito será cancelado caso o alvo receba algum ataque.",
                necessaryLevel: 10,
            },
            {
                level: 3,
                cooldown: 40,
                mp: 88,
                cast: 2,
                info:
                    "Transforma o inimigo em um coelho durante 24 segundos reduzindo 24 da sua velocidade de movimento e também reduzindo significativamente sua vida, mana, defesa física e defesa mágica inibindo o alvo de contra-ataques. Efeito será cancelado caso o alvo receba algum ataque.",
                necessaryLevel: 14,
            },
            {
                level: 4,
                cooldown: 40,
                mp: 109,
                cast: 2,
                info:
                    "Transforma o inimigo em um coelho durante 26 segundos reduzindo 26 da sua velocidade de movimento e também reduzindo significativamente sua vida, mana, defesa física e defesa mágica inibindo o alvo de contra-ataques. Efeito será cancelado caso o alvo receba algum ataque.",
                necessaryLevel: 18,
            },
            {
                level: 5,
                cooldown: 40,
                mp: 134,
                cast: 2,
                info:
                    "Transforma o inimigo em um coelho durante 28 segundos reduzindo 28 da sua velocidade de movimento e também reduzindo significativamente sua vida, mana, defesa física e defesa mágica inibindo o alvo de contra-ataques. Efeito será cancelado caso o alvo receba algum ataque.",
                necessaryLevel: 22,
            },
            {
                level: 6,
                cooldown: 40,
                mp: 162,
                cast: 2,
                info:
                    "Transforma o inimigo em um coelho durante 30 segundos reduzindo 30 da sua velocidade de movimento e também reduzindo significativamente sua vida, mana, defesa física e defesa mágica inibindo o alvo de contra-ataques. Efeito será cancelado caso o alvo receba algum ataque.",
                necessaryLevel: 26,
            },
            {
                level: 7,
                cooldown: 40,
                mp: 196,
                cast: 2,
                info:
                    "Transforma o inimigo em um coelho durante 32 segundos reduzindo 32 da sua velocidade de movimento e também reduzindo significativamente sua vida, mana, defesa física e defesa mágica inibindo o alvo de contra-ataques. Efeito será cancelado caso o alvo receba algum ataque.",
                necessaryLevel: 30,
            },
            {
                level: 8,
                cooldown: 40,
                mp: 238,
                cast: 2,
                info:
                    "Transforma o inimigo em um coelho durante 34 segundos reduzindo 34 da sua velocidade de movimento e também reduzindo significativamente sua vida, mana, defesa física e defesa mágica inibindo o alvo de contra-ataques. Efeito será cancelado caso o alvo receba algum ataque.",
                necessaryLevel: 34,
            },
            {
                level: 9,
                cooldown: 40,
                mp: 288,
                cast: 2,
                info:
                    "Transforma o inimigo em um coelho durante 36 segundos reduzindo 36 da sua velocidade de movimento e também reduzindo significativamente sua vida, mana, defesa física e defesa mágica inibindo o alvo de contra-ataques. Efeito será cancelado caso o alvo receba algum ataque.",
                necessaryLevel: 38,
            },
            {
                level: 10,
                cooldown: 40,
                mp: 342,
                cast: 2,
                info:
                    "Transforma o inimigo em um coelho durante 38 segundos reduzindo 40 da sua velocidade de movimento e também reduzindo significativamente sua vida, mana, defesa física e defesa mágica inibindo o alvo de contra-ataques. Efeito será cancelado caso o alvo receba algum ataque.",
                necessaryLevel: 42,
            },
        ],
    },
    {
        logoId: 4,
        name: "Onda de choque",
        levelsInfo: [
            {
                level: 1,
                cooldown: 1,
                mp: 66,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 94 de dano mágico e reduz em 15 a velocidade de movimento durante 3 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 8,
            },
            {
                level: 2,
                cooldown: 1,
                mp: 83,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 118 de dano mágico e reduz em 16 a velocidade de movimento durante 3 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 12,
            },
            {
                level: 3,
                cooldown: 1,
                mp: 103,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 147 de dano mágico e reduz em 17 a velocidade de movimento durante 3 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 16,
            },
            {
                level: 4,
                cooldown: 1,
                mp: 127,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 181 de dano mágico e reduz em 18 a velocidade de movimento durante 3 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 20,
            },
            {
                level: 5,
                cooldown: 1,
                mp: 154,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 220 de dano mágico e reduz em 19 a velocidade de movimento durante 4 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 24,
            },
            {
                level: 6,
                cooldown: 1,
                mp: 187,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 267 de dano mágico e reduz em 20 a velocidade de movimento durante 4 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 28,
            },
            {
                level: 7,
                cooldown: 1,
                mp: 227,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 324 de dano mágico e reduz em 21 a velocidade de movimento durante 4 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 32,
            },
            {
                level: 8,
                cooldown: 1,
                mp: 274,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 391 de dano mágico e reduz em 22 a velocidade de movimento durante 4 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 36,
            },
            {
                level: 9,
                cooldown: 1,
                mp: 330,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 472 de dano mágico e reduz em 23 a velocidade de movimento durante 5 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 40,
            },
            {
                level: 10,
                cooldown: 1,
                mp: 390,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 557 de dano mágico e reduz em 24 a velocidade de movimento durante 5 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 44,
            },
            {
                level: 11,
                cooldown: 1,
                mp: 461,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 658 de dano mágico e reduz em 25 a velocidade de movimento durante 5 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 48,
            },
            {
                level: 12,
                cooldown: 1,
                mp: 535,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 764 de dano mágico e reduz em 26 a velocidade de movimento durante 5 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 52,
            },
            {
                level: 13,
                cooldown: 1,
                mp: 619,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 884 de dano mágico e reduz em 27 a velocidade de movimento durante 6 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 56,
            },
            {
                level: 14,
                cooldown: 1,
                mp: 712,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 1010 de dano mágico e reduz em 28 a velocidade de movimento durante 6 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 60,
            },
            {
                level: 15,
                cooldown: 1,
                mp: 800,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 1143 de dano mágico e reduz em 29 a velocidade de movimento durante 6 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 64,
            },
            {
                level: 16,
                cooldown: 1,
                mp: 899,
                cast: 1,
                info:
                    "Canaliza uma esfera elétrica que causa 1284 de dano mágico e reduz em 30 a velocidade de movimento durante 6 segundos. O alvo entra no efeito Elétrico.",
                necessaryLevel: 68,
            },
        ],
    },
    {
        logoId: 5,
        name: "Escudo Negro",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 178,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 30% de todo o dano recebido reduzindo em 1.35 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 10,
            },
            {
                level: 2,
                cooldown: 60,
                mp: 222,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 32% de todo o dano recebido reduzindo em 1.30 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 14,
            },
            {
                level: 3,
                cooldown: 60,
                mp: 273,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 34% de todo o dano recebido reduzindo em 1.25 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 18,
            },
            {
                level: 4,
                cooldown: 60,
                mp: 355,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 36% de todo o dano recebido reduzindo em 1.20 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 22,
            },
            {
                level: 5,
                cooldown: 60,
                mp: 425,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 38% de todo o dano recebido reduzindo em 1.15 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 26,
            },
            {
                level: 6,
                cooldown: 60,
                mp: 508,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 40% de todo o dano recebido reduzindo em 1.10 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 30,
            },
            {
                level: 7,
                cooldown: 60,
                mp: 611,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 42% de todo o dano recebido reduzindo em 1.05 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 34,
            },
            {
                level: 8,
                cooldown: 60,
                mp: 733,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 44% de todo o dano recebido reduzindo a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 38,
            },
            {
                level: 9,
                cooldown: 60,
                mp: 916,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 46% de todo o dano recebido reduzindo em 0.95 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 42,
            },
            {
                level: 10,
                cooldown: 60,
                mp: 1070,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 48% de todo o dano recebido reduzindo em 0.90 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 46,
            },
            {
                level: 11,
                cooldown: 60,
                mp: 1318,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 50% de todo o dano recebido reduzindo em 0.85 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 50,
            },
            {
                level: 12,
                cooldown: 60,
                mp: 1509,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 52% de todo o dano recebido reduzindo em 0.80 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 54,
            },
            {
                level: 13,
                cooldown: 60,
                mp: 1732,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 54% de todo o dano recebido reduzindo em 0.75 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 58,
            },
            {
                level: 14,
                cooldown: 60,
                mp: 1994,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 56% de todo o dano recebido reduzindo em 0.70 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 62,
            },
            {
                level: 15,
                cooldown: 60,
                mp: 2219,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 58% de todo o dano recebido reduzindo em 0.65 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 66,
            },
            {
                level: 16,
                cooldown: 60,
                mp: 2466,
                cast: 0,
                info:
                    "Invoca um escudo de magia negra que protege reduzindo 60% de todo o dano recebido reduzindo em 0.60 vezes a mana no valor do dano mitigado. O escudo é quebrado após 10 minutos ou ao esgotar a mana.",
                necessaryLevel: 70,
            },
        ],
    },
    {
        logoId: 6,
        name: "Inferno Caótico",
        levelsInfo: [
            {
                level: 1,
                cooldown: 40,
                mp: 122,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 213 de dano mágico e atordoa por 3 segundos. Causa 107 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 12,
            },
            {
                level: 2,
                cooldown: 39,
                mp: 153,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 265 de dano mágico e atordoa por 3 segundos. Causa 133 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 16,
            },
            {
                level: 3,
                cooldown: 38,
                mp: 188,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 327 de dano mágico e atordoa por 3 segundos. Causa 164 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 20,
            },
            {
                level: 4,
                cooldown: 37,
                mp: 228,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 397 de dano mágico e atordoa por 3 segundos. Causa 199 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 24,
            },
            {
                level: 5,
                cooldown: 36,
                mp: 276,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 481 de dano mágico e atordoa por 3 segundos. Causa 241 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 28,
            },
            {
                level: 6,
                cooldown: 35,
                mp: 335,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 592 de dano mágico e atordoa por 3 segundos. Causa 292 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 32,
            },
            {
                level: 7,
                cooldown: 34,
                mp: 405,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 705 de dano mágico e atordoa por 3 segundos. Causa 353 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 36,
            },
            {
                level: 8,
                cooldown: 33,
                mp: 489,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 851 de dano mágico e atordoa por 3 segundos. Causa 426 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 40,
            },
            {
                level: 9,
                cooldown: 32,
                mp: 576,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 1004 de dano mágico e atordoa por 3 segundos. Causa 502 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 44,
            },
            {
                level: 10,
                cooldown: 31,
                mp: 681,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 1185 de dano mágico e atordoa por 3 segundos. Causa 593 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 48,
            },
            {
                level: 11,
                cooldown: 30,
                mp: 790,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 1377 de dano mágico e atordoa por 3 segundos. Causa 689 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 52,
            },
            {
                level: 12,
                cooldown: 29,
                mp: 914,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 1593 de dano mágico e atordoa por 3 segundos. Causa 797 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 56,
            },
            {
                level: 13,
                cooldown: 28,
                mp: 1052,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 1820 de dano mágico e atordoa por 3 segundos. Causa 910 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 60,
            },
            {
                level: 14,
                cooldown: 27,
                mp: 1182,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 2060 de dano mágico e atordoa por 3 segundos. Causa 1030 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 64,
            },
            {
                level: 15,
                cooldown: 26,
                mp: 1328,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 2314 de dano mágico e atordoa por 3 segundos. Causa 1157 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 68,
            },
            {
                level: 16,
                cooldown: 25,
                mp: 1494,
                cast: 0,
                info:
                    "Dispara uma chama infernal que causa 2603 de dano mágico e atordoa por 3 segundos. Causa 1302 de dano mágico extra em alvos sob efeito de Chamas.",
                necessaryLevel: 72,
            },
        ],
    },
    {
        logoId: 7,
        name: "Impedimento",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 109,
                cast: 0,
                info:
                    "Lança uma maldição que causa 104 de dano mágico e o impede de utilizar habilidades durante 3 segundos e tem seu tempo dobrado caso o alvo esteja conjurando alguma habilidade. Alvos recebem 21 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 17,
            },
            {
                level: 2,
                cooldown: 58,
                mp: 134,
                cast: 0,
                info:
                    "Lança uma maldição que causa 128 de dano mágico e o impede de utilizar habilidades durante 4 segundos e tem seu tempo dobrado caso o alvo esteja conjurando alguma habilidade. Alvos recebem 26 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 21,
            },
            {
                level: 3,
                cooldown: 56,
                mp: 161,
                cast: 0,
                info:
                    "Lança uma maldição que causa 154 de dano mágico e o impede de utilizar habilidades durante 5 segundos e tem seu tempo dobrado caso o alvo esteja conjurando alguma habilidade. Alvos recebem 31 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 25,
            },
            {
                level: 4,
                cooldown: 54,
                mp: 195,
                cast: 0,
                info:
                    "Lança uma maldição que causa 187 de dano mágico e o impede de utilizar habilidades durante 6 segundos e tem seu tempo dobrado caso o alvo esteja conjurando alguma habilidade. Alvos recebem 37 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 29,
            },
            {
                level: 5,
                cooldown: 52,
                mp: 237,
                cast: 0,
                info:
                    "Lança uma maldição que causa 227 de dano mágico e o impede de utilizar habilidades durante 7 segundos e tem seu tempo dobrado caso o alvo esteja conjurando alguma habilidade. Alvos recebem 45 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 33,
            },
            {
                level: 6,
                cooldown: 50,
                mp: 288,
                cast: 0,
                info:
                    "Lança uma maldição que causa 275 de dano mágico e o impede de utilizar habilidades durante 8 segundos e tem seu tempo dobrado caso o alvo esteja conjurando alguma habilidade. Alvos recebem 55 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 37,
            },
            {
                level: 7,
                cooldown: 48,
                mp: 243,
                cast: 0,
                info:
                    "Lança uma maldição que causa 328 de dano mágico e o impede de utilizar habilidades durante 9 segundos e tem seu tempo dobrado caso o alvo esteja conjurando alguma habilidade. Alvos recebem 66 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 41,
            },
            {
                level: 8,
                cooldown: 46,
                mp: 404,
                cast: 0,
                info:
                    "Lança uma maldição que causa 387 de dano mágico e o impede de utilizar habilidades durante 10 segundos e tem seu tempo dobrado caso o alvo esteja conjurando alguma habilidade. Alvos recebem 77 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 45,
            },
            {
                level: 9,
                cooldown: 44,
                mp: 476,
                cast: 0,
                info:
                    "Lança uma maldição que causa 457 de dano mágico e o impede de utilizar habilidades durante 11 segundos e tem seu tempo dobrado caso o alvo esteja conjurando alguma habilidade. Alvos recebem 91 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 49,
            },
            {
                level: 10,
                cooldown: 40,
                mp: 551,
                cast: 0,
                info:
                    "Lança uma maldição que causa 529 de dano mágico e o impede de utilizar habilidades durante 12 segundos e tem seu tempo dobrado caso o alvo esteja conjurando alguma habilidade. Alvos recebem 106 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 53,
            },
        ],
    },
    {
        logoId: 8,
        name: "Corroer",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 96,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 173 de dano mágico e 100% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 30% durante 6 segundos.",
                necessaryLevel: 19,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 116,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 210 de dano mágico e 105% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 33% durante 6 segundos.",
                necessaryLevel: 23,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 141,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 255 de dano mágico e 110% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 36% durante 6 segundos.",
                necessaryLevel: 27,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 171,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 309 de dano mágico e 115% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 39% durante 6 segundos.",
                necessaryLevel: 31,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 208,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 375 de dano mágico e 120% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 42% durante 6 segundos.",
                necessaryLevel: 35,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 250,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 453 de dano mágico e 125% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 45% durante 6 segundos.",
                necessaryLevel: 39,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 296,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 536 de dano mágico e 130% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 48% durante 6 segundos.",
                necessaryLevel: 43,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 350,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 663 de dano mágico e 135% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 51% durante 6 segundos.",
                necessaryLevel: 47,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 408,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 738 de dano mágico e 140% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 54% durante 6 segundos.",
                necessaryLevel: 51,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 472,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 854 de dano mágico e 145% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 57% durante 6 segundos.",
                necessaryLevel: 55,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 546,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 980 de dano mágico e 150% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 60% durante 6 segundos.",
                necessaryLevel: 59,
            },
            {
                level: 12,
                cooldown: 20,
                mp: 615,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 1113 de dano mágico e 155% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 63% durante 6 segundos.",
                necessaryLevel: 63,
            },
            {
                level: 13,
                cooldown: 20,
                mp: 691,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 1250 de dano mágico e 160% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 66% durante 6 segundos.",
                necessaryLevel: 67,
            },
            {
                level: 14,
                cooldown: 20,
                mp: 777,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 1406 de dano mágico e 165% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 69% durante 6 segundos.",
                necessaryLevel: 71,
            },
            {
                level: 15,
                cooldown: 20,
                mp: 871,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 1575 de dano mágico e 170% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 72% durante 6 segundos.",
                necessaryLevel: 75,
            },
            {
                level: 16,
                cooldown: 20,
                mp: 967,
                cast: 0,
                info:
                    "Seu cajado transforma-se em uma foice das trevas causando 1749 de dano mágico e 175% do dano causado por essa habilidade será recuperado como vida, além de reduzir o ataque físico do alvo em 75% durante 6 segundos.",
                necessaryLevel: 79,
            },
        ],
    },
    {
        logoId: 9,
        name: "Tempestade de Mana",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Sobrecarrega a mana aumentando 5 de ataque mágico. Seus ataques ignoram 2% da defesa mágica do alvo consumindo 3 de mana adicionalmente.",
                necessaryLevel: 21,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Sobrecarrega a mana aumentando 10 de ataque mágico. Seus ataques ignoram 3% da defesa mágica do alvo consumindo 6 de mana adicionalmente.",
                necessaryLevel: 25,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Sobrecarrega a mana aumentando 15 de ataque mágico. Seus ataques ignoram 3% da defesa mágica do alvo consumindo 9 de mana adicionalmente.",
                necessaryLevel: 29,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Sobrecarrega a mana aumentando 20 de ataque mágico. Seus ataques ignoram 4% da defesa mágica do alvo consumindo 12 de mana adicionalmente.",
                necessaryLevel: 33,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Sobrecarrega a mana aumentando 25 de ataque mágico. Seus ataques ignoram 4% da defesa mágica do alvo consumindo 15 de mana adicionalmente.",
                necessaryLevel: 37,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Sobrecarrega a mana aumentando 30 de ataque mágico. Seus ataques ignoram 5% da defesa mágica do alvo consumindo 18 de mana adicionalmente.",
                necessaryLevel: 41,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Sobrecarrega a mana aumentando 35 de ataque mágico. Seus ataques ignoram 5% da defesa mágica do alvo consumindo 21 de mana adicionalmente.",
                necessaryLevel: 45,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Sobrecarrega a mana aumentando 40 de ataque mágico. Seus ataques ignoram 6% da defesa mágica do alvo consumindo 24 de mana adicionalmente.",
                necessaryLevel: 49,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Sobrecarrega a mana aumentando 45 de ataque mágico. Seus ataques ignoram 6% da defesa mágica do alvo consumindo 27 de mana adicionalmente.",
                necessaryLevel: 53,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Sobrecarrega a mana aumentando 50 de ataque mágico. Seus ataques ignoram 7% da defesa mágica do alvo consumindo 30 de mana adicionalmente.",
                necessaryLevel: 57,
            },
        ],
    },
    {
        logoId: 10,
        name: "Harmonia de Mana",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Harmoniza a mana convertendo 6% da mana máxima em vida. Todo benefício que influencie na alteração da mana máxima é desconsiderado.",
                necessaryLevel: 23,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Harmoniza a mana convertendo 7% da mana máxima em vida. Todo benefício que influencie na alteração da mana máxima é desconsiderado.",
                necessaryLevel: 27,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Harmoniza a mana convertendo 8% da mana máxima em vida. Todo benefício que influencie na alteração da mana máxima é desconsiderado.",
                necessaryLevel: 31,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Harmoniza a mana convertendo 9% da mana máxima em vida. Todo benefício que influencie na alteração da mana máxima é desconsiderado.",
                necessaryLevel: 35,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Harmoniza a mana convertendo 10% da mana máxima em vida. Todo benefício que influencie na alteração da mana máxima é desconsiderado.",
                necessaryLevel: 39,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Harmoniza a mana convertendo 11% da mana máxima em vida. Todo benefício que influencie na alteração da mana máxima é desconsiderado.",
                necessaryLevel: 43,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Harmoniza a mana convertendo 12% da mana máxima em vida. Todo benefício que influencie na alteração da mana máxima é desconsiderado.",
                necessaryLevel: 47,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Harmoniza a mana convertendo 13% da mana máxima em vida. Todo benefício que influencie na alteração da mana máxima é desconsiderado.",
                necessaryLevel: 51,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Harmoniza a mana convertendo 14% da mana máxima em vida. Todo benefício que influencie na alteração da mana máxima é desconsiderado.",
                necessaryLevel: 55,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Harmoniza a mana convertendo 15% da mana máxima em vida. Todo benefício que influencie na alteração da mana máxima é desconsiderado.",
                necessaryLevel: 59,
            },
        ],
    },
    {
        logoId: 11,
        name: "Enxame da Escuridão",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 407,
                cast: 10,
                info:
                    "Seleciona uma área para que uma chuva negra caia sobre seus inimigos causando 68 de dano mágico por segundo durante 10 segundos. Alvos recebem 5 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 25,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 494,
                cast: 10,
                info:
                    "Seleciona uma área para que uma chuva negra caia sobre seus inimigos causando 82 de dano mágico por segundo durante 10 segundos. Alvos recebem 10 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 29,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 599,
                cast: 10,
                info:
                    "Seleciona uma área para que uma chuva negra caia sobre seus inimigos causando 100 de dano mágico por segundo durante 10 segundos. Alvos recebem 15 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 33,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 726,
                cast: 10,
                info:
                    "Seleciona uma área para que uma chuva negra caia sobre seus inimigos causando 121 de dano mágico por segundo durante 10 segundos. Alvos recebem 20 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 37,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 866,
                cast: 10,
                info:
                    "Seleciona uma área para que uma chuva negra caia sobre seus inimigos causando 144 de dano mágico por segundo durante 10 segundos. Alvos recebem 25 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 41,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 1022,
                cast: 10,
                info:
                    "Seleciona uma área para que uma chuva negra caia sobre seus inimigos causando 170 de dano mágico por segundo durante 10 segundos. Alvos recebem 30 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 45,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 1207,
                cast: 10,
                info:
                    "Seleciona uma área para que uma chuva negra caia sobre seus inimigos causando 201 de dano mágico por segundo durante 10 segundos. Alvos recebem 35 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 49,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 1397,
                cast: 10,
                info:
                    "Seleciona uma área para que uma chuva negra caia sobre seus inimigos causando 233 de dano mágico por segundo durante 10 segundos. Alvos recebem 40 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 53,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 1618,
                cast: 10,
                info:
                    "Seleciona uma área para que uma chuva negra caia sobre seus inimigos causando 270 de dano mágico por segundo durante 10 segundos. Alvos recebem 45 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 57,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 1846,
                cast: 10,
                info:
                    "Seleciona uma área para que uma chuva negra caia sobre seus inimigos causando 308 de dano mágico por segundo durante 10 segundos. Alvos recebem 50 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 61,
            },
        ],
    },
    {
        logoId: 12,
        name: "Éclater",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 292,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 340 de dano mágico em uma área de 4 metros. Alvos recebem 34 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 27,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 353,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 412 de dano mágico em uma área de 4 metros. Alvos recebem 41 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 31,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 429,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 500 de dano mágico em uma área de 4 metros. Alvos recebem 50 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 35,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 518,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 604 de dano mágico em uma área de 4 metros. Alvos recebem 60 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 39,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 613,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 714 de dano mágico em uma área de 4 metros. Alvos recebem 71 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 43,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 725,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 840 de dano mágico em uma área de 4 metros. Alvos recebem 84 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 47,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 845,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 984 de dano mágico em uma área de 4 metros. Alvos recebem 98 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 51,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 977,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 1138 de dano mágico em uma área de 4 metros. Alvos recebem 114 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 55,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 1121,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 1306 de dano mágico em uma área de 4 metros. Alvos recebem 131 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 59,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 1274,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 1484 de dano mágico em uma área de 4 metros. Alvos recebem 148 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 63,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 1430,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 1666 de dano mágico em uma área de 4 metros. Alvos recebem 167 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 67,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 1608,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 1874 de dano mágico em uma área de 4 metros. Alvos recebem 187 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 71,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 1802,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 2100 de dano mágico em uma área de 4 metros. Alvos recebem 210 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 75,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 2001,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 2332 de dano mágico em uma área de 4 metros. Alvos recebem 233 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 79,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 2224,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 2592 de dano mágico em uma área de 4 metros. Alvos recebem 259 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 83,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 2469,
                cast: 0,
                info:
                    "Lança uma bomba mágica no alvo que explode após 20 segundos ou caso a vida do alvo chegue a 50%. A explosão causa 2878 de dano mágico em uma área de 4 metros. Alvos recebem 288 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 87,
            },
        ],
    },
    {
        logoId: 13,
        name: "Lança de Raio",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 359,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 378 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 132 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 32,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 433,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 457 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 160 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 36,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 523,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 551 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 193 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 40,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 617,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 651 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 228 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 44,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 728,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 768 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 269 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 48,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 846,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 893 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 313 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 52,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 979,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 1033 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 362 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 56,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 1127,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 1180 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 413 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 60,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 1266,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 1335 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 467 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 64,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 1422,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 1500 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 525 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 68,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 1599,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 1687 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 590 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 72,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 1789,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 1887 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 660 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 76,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 1986,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 2095 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 733 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 80,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 2206,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 2398 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 815 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 84,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 2451,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 2585 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 905 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 88,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 2722,
                cast: 0,
                info:
                    "Lança um poderoso raio no alvo causando 2872 de dano mágico. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 1005 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 92,
            },
        ],
    },
    {
        logoId: 14,
        name: "Esplendor Caótico",
        levelsInfo: [
            {
                level: 1,
                cooldown: 30,
                mp: 357,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 476 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 20 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 119 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 34,
            },
            {
                level: 2,
                cooldown: 29,
                mp: 432,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 576 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 22 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 144 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 38,
            },
            {
                level: 3,
                cooldown: 28,
                mp: 513,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 684 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 24 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 171 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 42,
            },
            {
                level: 4,
                cooldown: 27,
                mp: 605,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 806 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 26 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 202 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 46,
            },
            {
                level: 5,
                cooldown: 26,
                mp: 711,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 984 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 28 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 237 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 50,
            },
            {
                level: 6,
                cooldown: 25,
                mp: 822,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 1096 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 30 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 274 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 54,
            },
            {
                level: 7,
                cooldown: 24,
                mp: 954,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 1264 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 32 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 316 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 58,
            },
            {
                level: 8,
                cooldown: 23,
                mp: 1080,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 1440 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 34 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 360 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 62,
            },
            {
                level: 9,
                cooldown: 22,
                mp: 1214,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 1618 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 36 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 405 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 66,
            },
            {
                level: 10,
                cooldown: 21,
                mp: 1364,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 1818 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 38 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 455 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 70,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 1533,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 2044 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 40 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 511 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 74,
            },
            {
                level: 12,
                cooldown: 19,
                mp: 1704,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 2272 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 42 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 568 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 78,
            },
            {
                level: 13,
                cooldown: 18,
                mp: 1893,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 2524 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 44 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 631 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 82,
            },
            {
                level: 14,
                cooldown: 17,
                mp: 2103,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 2804 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 46 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 701 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 86,
            },
            {
                level: 15,
                cooldown: 16,
                mp: 2334,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 3114 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 48 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 778 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 90,
            },
            {
                level: 16,
                cooldown: 15,
                mp: 2594,
                cast: 0,
                info:
                    "Libera uma explosão incendiária em sua volta causando 3458 de dano mágico em uma área de 5 metros onde os alvos atingidos sofrem 50 de redução na velocidade de movimento durante 8 segundos. Alvos recebem 865 de dano mágico extra sob efeito de Chamas.",
                necessaryLevel: 94,
            },
        ],
    },
    {
        logoId: 15,
        name: "Bruma Sonífera",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 561,
                cast: 0,
                info:
                    "Cria uma neblina mágica que causa Sono nos alvos em uma área de 5 metros durante 4 segundos. Alvos serão despertados caso recebam algum efeito durante o estado e as habilidades direcionadas aos alvos sob o efeito de Sono sempre causarão acerto crítico quando atingidas.",
                necessaryLevel: 36,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 677,
                cast: 0,
                info:
                    "Cria uma neblina mágica que causa Sono nos alvos em uma área de 5 metros durante 8 segundos. Alvos serão despertados caso recebam algum efeito durante o estado e as habilidades direcionadas aos alvos sob o efeito de Sono sempre causarão acerto crítico quando atingidas.",
                necessaryLevel: 40,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 798,
                cast: 0,
                info:
                    "Cria uma neblina mágica que causa Sono nos alvos em uma área de 5 metros durante 12 segundos. Alvos serão despertados caso recebam algum efeito durante o estado e as habilidades direcionadas aos alvos sob o efeito de Sono sempre causarão acerto crítico quando atingidas.",
                necessaryLevel: 44,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 942,
                cast: 0,
                info:
                    "Cria uma neblina mágica que causa Sono nos alvos em uma área de 5 metros durante 16 segundos. Alvos serão despertados caso recebam algum efeito durante o estado e as habilidades direcionadas aos alvos sob o efeito de Sono sempre causarão acerto crítico quando atingidas.",
                necessaryLevel: 48,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 1094,
                cast: 0,
                info:
                    "Cria uma neblina mágica que causa Sono nos alvos em uma área de 5 metros durante 20 segundos. Alvos serão despertados caso recebam algum efeito durante o estado e as habilidades direcionadas aos alvos sob o efeito de Sono sempre causarão acerto crítico quando atingidas.",
                necessaryLevel: 52,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 1266,
                cast: 0,
                info:
                    "Cria uma neblina mágica que causa Sono nos alvos em uma área de 5 metros durante 24 segundos. Alvos serão despertados caso recebam algum efeito durante o estado e as habilidades direcionadas aos alvos sob o efeito de Sono sempre causarão acerto crítico quando atingidas.",
                necessaryLevel: 56,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 1455,
                cast: 0,
                info:
                    "Cria uma neblina mágica que causa Sono nos alvos em uma área de 5 metros durante 28 segundos. Alvos serão despertados caso recebam algum efeito durante o estado e as habilidades direcionadas aos alvos sob o efeito de Sono sempre causarão acerto crítico quando atingidas.",
                necessaryLevel: 60,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 1635,
                cast: 0,
                info:
                    "Cria uma neblina mágica que causa Sono nos alvos em uma área de 5 metros durante 32 segundos. Alvos serão despertados caso recebam algum efeito durante o estado e as habilidades direcionadas aos alvos sob o efeito de Sono sempre causarão acerto crítico quando atingidas.",
                necessaryLevel: 64,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 1838,
                cast: 0,
                info:
                    "Cria uma neblina mágica que causa Sono nos alvos em uma área de 5 metros durante 36 segundos. Alvos serão despertados caso recebam algum efeito durante o estado e as habilidades direcionadas aos alvos sob o efeito de Sono sempre causarão acerto crítico quando atingidas.",
                necessaryLevel: 68,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 2067,
                cast: 0,
                info:
                    "Cria uma neblina mágica que causa Sono nos alvos em uma área de 5 metros durante 40 segundos. Alvos serão despertados caso recebam algum efeito durante o estado e as habilidades direcionadas aos alvos sob o efeito de Sono sempre causarão acerto crítico quando atingidas.",
                necessaryLevel: 72,
            },
        ],
    },
    {
        logoId: 16,
        name: "Mão da Escuridão",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 501,
                cast: 0,
                info:
                    "Manipula os 3 elementos negros e os lança em seu alvo amaldiçoando-o sob efeito de Chamas, Escuridão e Elétrico nível 1 reduzindo a defesa mágica em 6% durante 10 segundos.",
                necessaryLevel: 38,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 595,
                cast: 0,
                info:
                    "Manipula os 3 elementos negros e os lança em seu alvo amaldiçoando-o sob efeito de Chamas, Escuridão e Elétrico nível 2 reduzindo a defesa mágica em 7% durante 11 segundos.",
                necessaryLevel: 42,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 701,
                cast: 0,
                info:
                    "Manipula os 3 elementos negros e os lança em seu alvo amaldiçoando-o sob efeito de Chamas, Escuridão e Elétrico nível 3 reduzindo a defesa mágica em 8% durante 12 segundos.",
                necessaryLevel: 46,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 824,
                cast: 0,
                info:
                    "Manipula os 3 elementos negros e os lança em seu alvo amaldiçoando-o sob efeito de Chamas, Escuridão e Elétrico nível 4 reduzindo a defesa mágica em 9% durante 13 segundos.",
                necessaryLevel: 50,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 953,
                cast: 0,
                info:
                    "Manipula os 3 elementos negros e os lança em seu alvo amaldiçoando-o sob efeito de Chamas, Escuridão e Elétrico nível 5 reduzindo a defesa mágica em 10% durante 14 segundos.",
                necessaryLevel: 54,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 1098,
                cast: 0,
                info:
                    "Manipula os 3 elementos negros e os lança em seu alvo amaldiçoando-o sob efeito de Chamas, Escuridão e Elétrico nível 6 reduzindo a defesa mágica em 11% durante 15 segundos.",
                necessaryLevel: 58,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 1251,
                cast: 0,
                info:
                    "Manipula os 3 elementos negros e os lança em seu alvo amaldiçoando-o sob efeito de Chamas, Escuridão e Elétrico nível 7 reduzindo a defesa mágica em 12% durante 16 segundos.",
                necessaryLevel: 62,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 1406,
                cast: 0,
                info:
                    "Manipula os 3 elementos negros e os lança em seu alvo amaldiçoando-o sob efeito de Chamas, Escuridão e Elétrico nível 8 reduzindo a defesa mágica em 13% durante 17 segundos.",
                necessaryLevel: 66,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 1579,
                cast: 0,
                info:
                    "Manipula os 3 elementos negros e os lança em seu alvo amaldiçoando-o sob efeito de Chamas, Escuridão e Elétrico nível 9 reduzindo a defesa mágica em 14% durante 18 segundos.",
                necessaryLevel: 70,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 1776,
                cast: 0,
                info:
                    "Manipula os 3 elementos negros e os lança em seu alvo amaldiçoando-o sob efeito de Chamas, Escuridão e Elétrico nível 10 reduzindo a defesa mágica em 15% durante 20 segundos.",
                necessaryLevel: 74,
            },
        ],
    },
    {
        logoId: 17,
        name: "Teleporte em Massa",
        levelsInfo: [
            {
                level: 1,
                cooldown: 600,
                mp: 1697,
                cast: 6,
                info:
                    "Canaliza mana e teleporta todos os membros do grupo que estiverem em uma área de 10 metros para uma coordenada salva. Ao utilizar a habilidade 1 espaço surgirá para salvar, substituir ou teleportar a uma coordenada.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 600,
                mp: 1982,
                cast: 6,
                info:
                    "Canaliza mana e teleporta todos os membros do grupo que estiverem em uma área de 10 metros para uma coordenada salva. Ao utilizar a habilidade 2 espaços surgirão para salvar, substituir ou teleportar a uma coordenada.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 600,
                mp: 2317,
                cast: 6,
                info:
                    "Canaliza mana e teleporta todos os membros do grupo que estiverem em uma área de 10 metros para uma coordenada salva. Ao utilizar a habilidade 3 espaços surgirão para salvar, substituir ou teleportar a uma coordenada.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 600,
                mp: 2820,
                cast: 6,
                info:
                    "Canaliza mana e teleporta todos os membros do grupo que estiverem em uma área de 10 metros para uma coordenada salva. Ao utilizar a habilidade 4 espaços surgirão para salvar, substituir ou teleportar a uma coordenada.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 600,
                mp: 3232,
                cast: 6,
                info:
                    "Canaliza mana e teleporta todos os membros do grupo que estiverem em uma área de 10 metros para uma coordenada salva. Ao utilizar a habilidade 5 espaços surgirão para salvar, substituir ou teleportar a uma coordenada.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 480,
                mp: 3779,
                cast: 6,
                info:
                    "Canaliza mana e teleporta todos os membros do grupo que estiverem em uma área de 10 metros para uma coordenada salva. Ao utilizar a habilidade 5 espaços surgirão para salvar, substituir ou teleportar a uma coordenada.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 360,
                mp: 4203,
                cast: 6,
                info:
                    "Canaliza mana e teleporta todos os membros do grupo que estiverem em uma área de 10 metros para uma coordenada salva. Ao utilizar a habilidade 5 espaços surgirão para salvar, substituir ou teleportar a uma coordenada.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 240,
                mp: 4675,
                cast: 6,
                info:
                    "Canaliza mana e teleporta todos os membros do grupo que estiverem em uma área de 10 metros para uma coordenada salva. Ao utilizar a habilidade 5 espaços surgirão para salvar, substituir ou teleportar a uma coordenada.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 5203,
                cast: 6,
                info:
                    "Canaliza mana e teleporta todos os membros do grupo que estiverem em uma área de 10 metros para uma coordenada salva. Ao utilizar a habilidade 5 espaços surgirão para salvar, substituir ou teleportar a uma coordenada.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 60,
                mp: 5909,
                cast: 6,
                info:
                    "Canaliza mana e teleporta todos os membros do grupo que estiverem em uma área de 10 metros para uma coordenada salva. Ao utilizar a habilidade 5 espaços surgirão para salvar, substituir ou teleportar a uma coordenada.",
                necessaryLevel: 76,
            },
        ],
    },
    {
        logoId: 18,
        name: "Queda Negra",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 1799,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 2399 de dano mágico e atordoa por 5 segundos. Alvos recebem 239 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 60,
                mp: 2125,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 2833 de dano mágico e atordoa por 5 segundos. Alvos recebem 283 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 60,
                mp: 2507,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 3343 de dano mágico e atordoa por 5 segundos. Alvos recebem 334 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 60,
                mp: 2913,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 3884 de dano mágico e atordoa por 5 segundos. Alvos recebem 388 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 60,
                mp: 3370,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 4493 de dano mágico e atordoa por 5 segundos. Alvos recebem 449 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 60,
                mp: 3850,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 5133 de dano mágico e atordoa por 5 segundos. Alvos recebem 513 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 60,
                mp: 4358,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 5811 de dano mágico e atordoa por 5 segundos. Alvos recebem 581 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 60,
                mp: 4895,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 6527 de dano mágico e atordoa por 5 segundos. Alvos recebem 652 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 60,
                mp: 5507,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 7342 de dano mágico e atordoa por 5 segundos. Alvos recebem 734 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 60,
                mp: 6158,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 8210 de dano mágico e atordoa por 5 segundos. Alvos recebem 821 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 76,
            },
            {
                level: 11,
                cooldown: 60,
                mp: 6837,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 9116 de dano mágico e atordoa por 5 segundos. Alvos recebem 911 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 80,
            },
            {
                level: 12,
                cooldown: 60,
                mp: 7597,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 10129 de dano mágico e atordoa por 5 segundos. Alvos recebem 1012 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 84,
            },
            {
                level: 13,
                cooldown: 60,
                mp: 8437,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 11249 de dano mágico e atordoa por 5 segundos. Alvos recebem 1124 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 88,
            },
            {
                level: 14,
                cooldown: 60,
                mp: 9288,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 12384 de dano mágico e atordoa por 5 segundos. Alvos recebem 1238 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 92,
            },
            {
                level: 15,
                cooldown: 60,
                mp: 10225,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 13633 de dano mágico e atordoa por 5 segundos. Alvos recebem 1363 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 96,
            },
            {
                level: 16,
                cooldown: 60,
                mp: 11258,
                cast: 5,
                info:
                    "Seleciona uma área de 6 metros e canaliza durante 5 segundos um meteoro que causa 15011 de dano mágico e atordoa por 5 segundos. Alvos recebem 1501 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 19,
        name: "Vínculo Quebrado",
        levelsInfo: [
            {
                level: 1,
                cooldown: 3,
                mp: 168,
                cast: 0,
                info:
                    "Causa 984 de dano mágico ao custo de 75% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 197 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 51,
            },
            {
                level: 2,
                cooldown: 3,
                mp: 194,
                cast: 0,
                info:
                    "Causa 1138 de dano mágico ao custo de 73% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 228 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 55,
            },
            {
                level: 3,
                cooldown: 3,
                mp: 222,
                cast: 0,
                info:
                    "Causa 1304 de dano mágico ao custo de 71% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 261 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 59,
            },
            {
                level: 4,
                cooldown: 3,
                mp: 253,
                cast: 0,
                info:
                    "Causa 1484 de dano mágico ao custo de 69% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 297 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 63,
            },
            {
                level: 5,
                cooldown: 3,
                mp: 284,
                cast: 0,
                info:
                    "Causa 1668 de dano mágico ao custo de 67% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 334 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 67,
            },
            {
                level: 6,
                cooldown: 3,
                mp: 319,
                cast: 0,
                info:
                    "Causa 1874 de dano mágico ao custo de 65% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 375 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 71,
            },
            {
                level: 7,
                cooldown: 3,
                mp: 357,
                cast: 0,
                info:
                    "Causa 2102 de dano mágico ao custo de 63% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 420 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 75,
            },
            {
                level: 8,
                cooldown: 3,
                mp: 397,
                cast: 0,
                info:
                    "Causa 2332 de dano mágico ao custo de 61% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 466 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 79,
            },
            {
                level: 9,
                cooldown: 3,
                mp: 441,
                cast: 0,
                info:
                    "Causa 2592 de dano mágico ao custo de 59% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 518 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 83,
            },
            {
                level: 10,
                cooldown: 3,
                mp: 490,
                cast: 0,
                info:
                    "Causa 2880 de dano mágico ao custo de 57% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 576 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 87,
            },
            {
                level: 11,
                cooldown: 3,
                mp: 544,
                cast: 0,
                info:
                    "Causa 3198 de dano mágico ao custo de 55% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 640 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 91,
            },
            {
                level: 12,
                cooldown: 3,
                mp: 604,
                cast: 0,
                info:
                    "Causa 3550 de dano mágico ao custo de 53% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 710 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 95,
            },
            {
                level: 13,
                cooldown: 3,
                mp: 671,
                cast: 0,
                info:
                    "Causa 3944 de dano mágico ao custo de 50% do dano causado ser retornado a você que não é reduzido pelo Escudo Negro, mas também não o mata. Alvos recebem 789 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 20,
        name: "Afinidade Negra",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra o silêncio em 5% e a resistência ao medo em 3%.",
                necessaryLevel: 55,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra o silêncio em 10% e a resistência ao medo em 6%.",
                necessaryLevel: 59,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra o silêncio em 15% e a resistência ao medo em 9%.",
                necessaryLevel: 63,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra o silêncio em 20% e a resistência ao medo em 12%.",
                necessaryLevel: 67,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra o silêncio em 25% e a resistência ao medo em 15%.",
                necessaryLevel: 71,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra o silêncio em 30% e a resistência ao medo em 18%.",
                necessaryLevel: 75,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra o silêncio em 35% e a resistência ao medo em 21%.",
                necessaryLevel: 79,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra o silêncio em 40% e a resistência ao medo em 24%.",
                necessaryLevel: 83,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra o silêncio em 45% e a resistência ao medo em 27%.",
                necessaryLevel: 87,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra o silêncio em 50% e a resistência ao medo em 30%.",
                necessaryLevel: 91,
            },
        ],
    },
    {
        logoId: 21,
        name: "Pecados Mortais",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 4633,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 572 de dano mágico por segundo durante 12 segundos reduzindo em 10 a velocidade de movimento. Alvos recebem 57 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 59,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 5233,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 646 de dano mágico por segundo durante 12 segundos reduzindo em 12 a velocidade de movimento. Alvos recebem 64 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 63,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 5873,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 725 de dano mágico por segundo durante 12 segundos reduzindo em 14 a velocidade de movimento. Alvos recebem 72 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 67,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 6602,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 815 de dano mágico por segundo durante 12 segundos reduzindo em 16 a velocidade de movimento. Alvos recebem 81 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 71,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 7403,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 914 de dano mágico por segundo durante 12 segundos reduzindo em 18 a velocidade de movimento. Alvos recebem 91 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 75,
            },
            {
                level: 6,
                cooldown: 180,
                mp: 8213,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 1014 de dano mágico por segundo durante 12 segundos reduzindo em 20 a velocidade de movimento. Alvos recebem 101 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 79,
            },
            {
                level: 7,
                cooldown: 180,
                mp: 9137,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 1128 de dano mágico por segundo durante 12 segundos reduzindo em 22 a velocidade de movimento. Alvos recebem 112 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 83,
            },
            {
                level: 8,
                cooldown: 180,
                mp: 10141,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 1252 de dano mágico por segundo durante 12 segundos reduzindo em 24 a velocidade de movimento. Alvos recebem 125 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 87,
            },
            {
                level: 9,
                cooldown: 180,
                mp: 11259,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 1390 de dano mágico por segundo durante 12 segundos reduzindo em 26 a velocidade de movimento. Alvos recebem 139 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 91,
            },
            {
                level: 10,
                cooldown: 180,
                mp: 12506,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 1544 de dano mágico por segundo durante 12 segundos reduzindo em 28 a velocidade de movimento. Alvos recebem 154 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 95,
            },
            {
                level: 11,
                cooldown: 180,
                mp: 13892,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros e invoca almas que causam 1715 de dano mágico por segundo durante 12 segundos reduzindo em 30 a velocidade de movimento. Alvos recebem 171 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 22,
        name: "Proeminência",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 1259,
                cast: 0,
                info:
                    "Invoca um pilar flamejante causando 1678 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 553 de dano mágico quando o choque é interrompido e 420 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 61,
            },
            {
                level: 2,
                cooldown: 60,
                mp: 1415,
                cast: 0,
                info:
                    "Invoca um pilar flamejante causando 1886 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 662 de dano mágico quando o choque é interrompido e 472 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 65,
            },
            {
                level: 3,
                cooldown: 60,
                mp: 1592,
                cast: 0,
                info:
                    "Invoca um pilar flamejante causando 2122 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 700 de dano mágico quando o choque é interrompido e 531 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 69,
            },
            {
                level: 4,
                cooldown: 60,
                mp: 1790,
                cast: 0,
                info:
                    "Invoca um pilar flamejante causando 2386 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 787 de dano mágico quando o choque é interrompido e 597 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 73,
            },
            {
                level: 5,
                cooldown: 60,
                mp: 1993,
                cast: 0,
                info:
                    "Invoca um pilar flamejante causando 2657 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 876 de dano mágico quando o choque é interrompido e 664 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 77,
            },
            {
                level: 6,
                cooldown: 60,
                mp: 2213,
                cast: 0,
                info:
                    "Invoca um pilar flamejante causando 2950 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 973 de dano mágico quando o choque é interrompido e 738 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 81,
            },
            {
                level: 7,
                cooldown: 60,
                mp: 2457,
                cast: 0,
                info:
                    "Invoca um pilar flamejante causando 3276 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 1081 de dano mágico quando o choque é interrompido e 819 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 85,
            },
            {
                level: 8,
                cooldown: 60,
                mp: 2729,
                cast: 0,
                info:
                    "Invoca um pilar flamejante causando 3638 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 1200 de dano mágico quando o choque é interrompido e 910 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 89,
            },
            {
                level: 9,
                cooldown: 60,
                mp: 3032,
                cast: 0,
                info:
                    "Invoca um pilar flamejante causando 4042 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 1333 de dano mágico quando o choque é interrompido e 1011 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 93,
            },
            {
                level: 10,
                cooldown: 60,
                mp: 3368,
                cast: 0,
                info:
                    "Invoca um pilar flamejante causando 4490 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 1481 de dano mágico quando o choque é interrompido e 1123 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 97,
            },
            {
                level: 11,
                cooldown: 60,
                mp: 3548,
                info:
                    "Invoca um pilar flamejante causando 4730 de dano mágico a qualquer inimigo em um raio de 4 metros e os deixa em choque por 3 segundos. Adiciona 1560 de dano mágico quando o choque é interrompido e 1183 de dano mágico aos inimigos sob efeito de Chamas.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 23,
        name: "Focar Mágica",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra cancelamento de habilidades ao receber um ataque em 4% e reduz em 5% o consumo de mana.",
                necessaryLevel: 65,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra cancelamento de habilidades ao receber um ataque em 8% e reduz em 6% o consumo de mana.",
                necessaryLevel: 69,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra cancelamento de habilidades ao receber um ataque em 12% e reduz em 7% o consumo de mana.",
                necessaryLevel: 73,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra cancelamento de habilidades ao receber um ataque em 16% e reduz em 8% o consumo de mana.",
                necessaryLevel: 77,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra cancelamento de habilidades ao receber um ataque em 20% e reduz em 9% o consumo de mana.",
                necessaryLevel: 81,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra cancelamento de habilidades ao receber um ataque em 24% e reduz em 10% o consumo de mana.",
                necessaryLevel: 85,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra cancelamento de habilidades ao receber um ataque em 28% e reduz em 11% o consumo de mana.",
                necessaryLevel: 89,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra cancelamento de habilidades ao receber um ataque em 32% e reduz em 12% o consumo de mana.",
                necessaryLevel: 93,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra cancelamento de habilidades ao receber um ataque em 36% e reduz em 13% o consumo de mana.",
                necessaryLevel: 97,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência contra cancelamento de habilidades ao receber um ataque em 40% e reduz em 15% o consumo de mana.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 24,
        name: "Tempestade de Raios",
        levelsInfo: [
            {
                level: 1,
                cooldown: 300,
                mp: 4551,
                cast: 6,
                info:
                    "Seleciona uma área de 6 metros criando uma tempestade de raios que causa 884 de dano mágico por 5 vezes e reduz em 50 a velocidade de movimento quebrando até 3 barreiras mágicas por ataque. Alvos recebem 159 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 69,
            },
            {
                level: 2,
                cooldown: 300,
                mp: 5103,
                cast: 6,
                info:
                    "Seleciona uma área de 6 metros criando uma tempestade de raios que causa 994 de dano mágico por 5 vezes e reduz em 50 a velocidade de movimento quebrando até 3 barreiras mágicas por ataque. Alvos recebem 179 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 73,
            },
            {
                level: 3,
                cooldown: 300,
                mp: 5757,
                cast: 6,
                info:
                    "Seleciona uma área de 6 metros criando uma tempestade de raios que causa 1107 de dano mágico por 5 vezes e reduz em 50 a velocidade de movimento quebrando até 3 barreiras mágicas por ataque. Alvos recebem 199 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 77,
            },
            {
                level: 4,
                cooldown: 300,
                mp: 6369,
                cast: 6,
                info:
                    "Seleciona uma área de 6 metros criando uma tempestade de raios que causa 1229 de dano mágico por 5 vezes e reduz em 50 a velocidade de movimento quebrando até 3 barreiras mágicas por ataque. Alvos recebem 221 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 81,
            },
            {
                level: 5,
                cooldown: 300,
                mp: 7053,
                cast: 6,
                info:
                    "Seleciona uma área de 6 metros criando uma tempestade de raios que causa 1365 de dano mágico por 5 vezes e reduz em 50 a velocidade de movimento quebrando até 3 barreiras mágicas por ataque. Alvos recebem 246 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 85,
            },
            {
                level: 6,
                cooldown: 300,
                mp: 7809,
                cast: 6,
                info:
                    "Seleciona uma área de 6 metros criando uma tempestade de raios que causa 1516 de dano mágico por 5 vezes e reduz em 50 a velocidade de movimento quebrando até 3 barreiras mágicas por ataque. Alvos recebem 273 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 89,
            },
            {
                level: 7,
                cooldown: 300,
                mp: 8817,
                cast: 6,
                info:
                    "Seleciona uma área de 6 metros criando uma tempestade de raios que causa 1684 de dano mágico por 5 vezes e reduz em 50 a velocidade de movimento quebrando até 3 barreiras mágicas por ataque. Alvos recebem 303 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 93,
            },
            {
                level: 8,
                cooldown: 300,
                mp: 9795,
                cast: 6,
                info:
                    "Seleciona uma área de 6 metros criando uma tempestade de raios que causa 1871 de dano mágico por 5 vezes e reduz em 50 a velocidade de movimento quebrando até 3 barreiras mágicas por ataque. Alvos recebem 337 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 97,
            },
            {
                level: 9,
                cooldown: 300,
                mp: 10320,
                cast: 6,
                info:
                    "Seleciona uma área de 6 metros criando uma tempestade de raios que causa 1971 de dano mágico por 5 vezes e reduz em 50 a velocidade de movimento quebrando até 3 barreiras mágicas por ataque. Alvos recebem 355 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 25,
        name: "Névoa Negra",
        levelsInfo: [
            {
                level: 1,
                cooldown: 240,
                mp: 3893,
                cast: 0,
                info:
                    "Convoca um escudo das sombras que durante 2 minutos absorve 8848 de dano físico e um benefício que aumenta 890 de habilidade de ataque, 25 de crítico e 31 de esquiva e absorve 25% do dano físico recebido de ataques a longa distância enquanto o escudo não for quebrado. Ao quebrar-se os efeitos do benefício permanecem.",
                necessaryLevel: 71,
            },
            {
                level: 2,
                cooldown: 240,
                mp: 4364,
                cast: 0,
                info:
                    "Convoca um escudo das sombras que durante 2 minutos absorve 9919 de dano físico e um benefício que aumenta 997 de habilidade de ataque, 28 de crítico e 33 de esquiva e absorve 25% do dano físico recebido de ataques a longa distância enquanto o escudo não for quebrado. Ao quebrar-se os efeitos do benefício permanecem.",
                necessaryLevel: 75,
            },
            {
                level: 3,
                cooldown: 240,
                mp: 4847,
                cast: 0,
                info:
                    "Convoca um escudo das sombras que durante 2 minutos absorve 11018 de dano físico e um benefício que aumenta 1107 de habilidade de ataque, 31 de crítico e 35 de esquiva e absorve 25% do dano físico recebido de ataques a longa distância enquanto o escudo não for quebrado. Ao quebrar-se os efeitos do benefício permanecem.",
                necessaryLevel: 79,
            },
            {
                level: 4,
                cooldown: 240,
                mp: 5386,
                cast: 0,
                info:
                    "Convoca um escudo das sombras que durante 2 minutos absorve 12243 de dano físico e um benefício que aumenta 1231 de habilidade de ataque, 34 de crítico e 37 de esquiva e absorve 25% do dano físico recebido de ataques a longa distância enquanto o escudo não for quebrado. Ao quebrar-se os efeitos do benefício permanecem.",
                necessaryLevel: 83,
            },
            {
                level: 5,
                cooldown: 240,
                mp: 5984,
                cast: 0,
                info:
                    "Convoca um escudo das sombras que durante 2 minutos absorve 13601 de dano físico e um benefício que aumenta 1367 de habilidade de ataque, 37 de crítico e 39 de esquiva e absorve 25% do dano físico recebido de ataques a longa distância enquanto o escudo não for quebrado. Ao quebrar-se os efeitos do benefício permanecem.",
                necessaryLevel: 87,
            },
            {
                level: 6,
                cooldown: 240,
                mp: 6643,
                cast: 0,
                info:
                    "Convoca um escudo das sombras que durante 2 minutos absorve 15099 de dano físico e um benefício que aumenta 1518 de habilidade de ataque, 40 de crítico e 41 de esquiva e absorve 25% do dano físico recebido de ataques a longa distância enquanto o escudo não for quebrado. Ao quebrar-se os efeitos do benefício permanecem.",
                necessaryLevel: 91,
            },
            {
                level: 7,
                cooldown: 240,
                mp: 7376,
                cast: 0,
                info:
                    "Convoca um escudo das sombras que durante 2 minutos absorve 16765 de dano físico e um benefício que aumenta 1686 de habilidade de ataque, 43 de crítico e 43 de esquiva e absorve 25% do dano físico recebido de ataques a longa distância enquanto o escudo não for quebrado. Ao quebrar-se os efeitos do benefício permanecem.",
                necessaryLevel: 95,
            },
            {
                level: 8,
                cooldown: 240,
                mp: 8192,
                cast: 0,
                info:
                    "Convoca um escudo das sombras que durante 2 minutos absorve 18620 de dano físico e um benefício que aumenta 1872 de habilidade de ataque, 46 de crítico e 45 de esquiva e absorve 25% do dano físico recebido de ataques a longa distância enquanto o escudo não for quebrado. Ao quebrar-se os efeitos do benefício permanecem.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 26,
        name: "Explosão das Trevas",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 2205,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros que causa 2940 de dano mágico e reduz em 3675 da mana dos alvos atingidos na qual é adicionada ao dano final. Alvos recebem 661 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 75,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 2449,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros que causa 3265 de dano mágico e reduz em 4081 da mana dos alvos atingidos na qual é adicionada ao dano final. Alvos recebem 734 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 79,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 2722,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros que causa 3629 de dano mágico e reduz em 4536 da mana dos alvos atingidos na qual é adicionada ao dano final. Alvos recebem 816 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 83,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 3022,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros que causa 4029 de dano mágico e reduz em 5037 da mana dos alvos atingidos na qual é adicionada ao dano final. Alvos recebem 906 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 87,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 3356,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros que causa 4474 de dano mágico e reduz em 5593 da mana dos alvos atingidos na qual é adicionada ao dano final. Alvos recebem 1006 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 91,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 3728,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros que causa 4970 de dano mágico e reduz em 6213 da mana dos alvos atingidos na qual é adicionada ao dano final. Alvos recebem 1118 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 95,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 4139,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros que causa 5519 de dano mágico e reduz em 6899 da mana dos alvos atingidos na qual é adicionada ao dano final. Alvos recebem 1241 de dano mágico extra sob efeito da Escuridão.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 27,
        name: "Trovão Ruinoso",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 2361,
                cast: 0,
                info:
                    "Conjura um trovão que causa 2099 de dano mágico em uma área de 3 metros e os faz receber 20% de dano mágico extra durante 3 segundos. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 378 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 79,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 2625,
                cast: 0,
                info:
                    "Conjura um trovão que causa 2333 de dano mágico em uma área de 3 metros e os faz receber 22% de dano mágico extra durante 3 segundos. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 420 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 83,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 2914,
                cast: 0,
                info:
                    "Conjura um trovão que causa 2590 de dano mágico em uma área de 3 metros e os faz receber 24% de dano mágico extra durante 3 segundos. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 466 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 87,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 3236,
                cast: 0,
                info:
                    "Conjura um trovão que causa 2876 de dano mágico em uma área de 3 metros e os faz receber 26% de dano mágico extra durante 3 segundos. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 518 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 91,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 3594,
                cast: 0,
                info:
                    "Conjura um trovão que causa 3195 de dano mágico em uma área de 3 metros e os faz receber 28% de dano mágico extra durante 3 segundos. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 575 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 95,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 3992,
                cast: 0,
                info:
                    "Conjura um trovão que causa 3548 de dano mágico em uma área de 3 metros e os faz receber 30% de dano mágico extra durante 3 segundos. Barreiras que bloqueiam habilidades ao serem atingidas por esta habilidade perdem 2 proteções. Alvos recebem 639 de dano mágico extra sob efeito Elétrico.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 28,
        name: "Cristalizar Mana",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 1613,
                cast: 0,
                info:
                    "Cristaliza seu alvo causando  2151 de dano mágico e capta 5% da sua mana atual atribuindo dano extra.",
                necessaryLevel: 81,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 1792,
                cast: 0,
                info:
                    "Cristaliza seu alvo causando  2389 de dano mágico e capta 6% da sua mana atual atribuindo dano extra.",
                necessaryLevel: 85,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 1990,
                cast: 0,
                info:
                    "Cristaliza seu alvo causando  2653 de dano mágico e capta 7% da sua mana atual atribuindo dano extra.",
                necessaryLevel: 89,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 2210,
                cast: 0,
                info:
                    "Cristaliza seu alvo causando  2947 de dano mágico e capta 8% da sua mana atual atribuindo dano extra.",
                necessaryLevel: 93,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 2456,
                cast: 0,
                info:
                    "Cristaliza seu alvo causando  3274 de dano mágico e capta 9% da sua mana atual atribuindo dano extra.",
                necessaryLevel: 97,
            },
            {
                level: 6,
                cooldown: 16,
                mp: 2556,
                cast: 0,
                info:
                    "Cristaliza seu alvo causando  3339 de dano mágico e capta 10% da sua mana atual atribuindo dano extra.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 29,
        name: "Tempestade",
        levelsInfo: [
            {
                level: 1,
                cooldown: 90,
                mp: 2064,
                cast: 0,
                info:
                    "Conjura uma explosão de gelo em uma área de 5 metros causando 2948 de dano mágico e atordoa os alvos atigindos em 3 segundos.",
                necessaryLevel: 85,
            },
            {
                level: 2,
                cooldown: 90,
                mp: 2293,
                cast: 0,
                info:
                    "Conjura uma explosão de gelo em uma área de 5 metros causando 3275 de dano mágico e atordoa os alvos atigindos em 4 segundos.",
                necessaryLevel: 89,
            },
            {
                level: 3,
                cooldown: 90,
                mp: 2546,
                cast: 0,
                info:
                    "Conjura uma explosão de gelo em uma área de 5 metros causando 3637 de dano mágico e atordoa os alvos atigindos em 5 segundos.",
                necessaryLevel: 93,
            },
            {
                level: 4,
                cooldown: 90,
                mp: 2829,
                cast: 0,
                info:
                    "Conjura uma explosão de gelo em uma área de 5 metros causando 4041 de dano mágico e atordoa os alvos atigindos em 6 segundos.",
                necessaryLevel: 97,
            },
            {
                level: 5,
                cooldown: 90,
                mp: 2980,
                cast: 0,
                info:
                    "Conjura uma explosão de gelo em uma área de 5 metros causando 4257 de dano mágico e atordoa os alvos atigindos em 7 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 30,
        name: "Furacão Negro",
        levelsInfo: [
            {
                level: 1,
                cooldown: 106,
                mp: 3153,
                cast: 0,
                info:
                    "Invoca uma ventania sombria que deixa os inimigos em choque e o veste com uma capa negra que aumenta a defesa. Se o alvo receber algum ataque durante o estado de choque recebe 6064 de dano mágico.",
                necessaryLevel: 89,
            },
            {
                level: 2,
                cooldown: 104,
                mp: 3503,
                cast: 0,
                info:
                    "Invoca uma ventania sombria que deixa os inimigos em choque e o veste com uma capa negra que aumenta a defesa. Se o alvo receber algum ataque durante o estado de choque recebe 6736 de dano mágico.",
                necessaryLevel: 93,
            },
            {
                level: 3,
                cooldown: 102,
                mp: 3892,
                cast: 0,
                info:
                    "Invoca uma ventania sombria que deixa os inimigos em choque e o veste com uma capa negra que aumenta a defesa. Se o alvo receber algum ataque durante o estado de choque recebe 7484 de dano mágico.",
                necessaryLevel: 97,
            },
            {
                level: 4,
                cooldown: 100,
                mp: 4100,
                cast: 0,
                info:
                    "Invoca uma ventania sombria que deixa os inimigos em choque e o veste com uma capa negra que aumenta a defesa. Se o alvo receber algum ataque durante o estado de choque recebe 7884 de dano mágico.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 31,
        name: "Portão Abissal",
        levelsInfo: [
            {
                level: 1,
                cooldown: 110,
                mp: 3911,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros que causa 3453 de dano mágico por segundo e reduz em 50 a velocidade de movimento da qual não pode ser removida durante 8 segundos. O alvo recebe 142 de dano mágico extra por cada efeito de maldição que possua.",
                necessaryLevel: 95,
            },
            {
                level: 2,
                cooldown: 110,
                mp: 4345,
                cast: 0,
                info:
                    "Seleciona uma área de 6 metros que causa 3834 de dano mágico por segundo e reduz em 50 a velocidade de movimento da qual não pode ser removida durante 8 segundos. O alvo recebe 158 de dano mágico extra por cada efeito de maldição que possua.",
                necessaryLevel: 99,
            },
        ],
    },
]